import script from "./LinkButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkButtons.vue?vue&type=script&setup=true&lang=js"

import "./LinkButtons.vue?vue&type=style&index=0&id=9b877690&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b877690"]])

export default __exports__